import { ThunkType } from "../../../../core/store/reducers";
import { getRefPriceExcel } from "../api/getRefPriceExcel";
import fileDownload from "js-file-download";
import { setDownloadFetchState } from "../tradingDataSlice";

export const downloadRefPriceExcel = (): ThunkType => async (
  dispatch,
  getStore
) => {

  const store = getStore();

  if (store.data.auth.current.status !== "successful") {
    return undefined;
  }

  const { filter } = store.ux.clearing.tradingData;
  const user = store.data.auth.current.user;

  dispatch(setDownloadFetchState({ type: "started" }));
  const dailyTrading = await dispatch(getRefPriceExcel(user, filter));
  if (dailyTrading) {
    fileDownload(
      new Blob([dailyTrading as any], {
        type: "application/vnd.openxmlformat",
      }),
      "RegPrice.xlsx"
    );
  }
  dispatch(setDownloadFetchState({ type: "not-started" }));
};
